/*
 * Copyright (c) 2023. American Express Company
 */

import { DebtModel } from 'src/types/debt.model';
import * as H from 'history';
import { FullUserModel } from 'src/types/user.model';

export class DebtDrawerViewModel {
    currentDebt: DebtModel;
    lastCashFlowEndDate: string;
    onStartupStep: boolean;
    handleBack: () => void;
    handleTopDrawer: () => void;
    handleAccounts: () => Promise<void>;
    handleOpenConfirmation: (confirmation: any) => void;
    handleReloadUser: () => Promise<any>;
    history: H.History;
    firstImport: boolean;
    handleClearFirstImport: () => void;
    handleFirstImport: () => void;
    setDrawer: () => void;
    user: FullUserModel;
}
